function normalizeMoneyString(value?: string | number) {
  const input = String(value ?? "").trim();
  if (!input) return "";

  const cleaned = input.replace(/[^\d,.-]/g, "");
  if (!cleaned || cleaned === "-" || cleaned === "," || cleaned === ".") return "";

  const negative = cleaned.startsWith("-");
  const unsigned = cleaned.replace(/-/g, "");
  let normalized = "";

  if (unsigned.includes(",")) {
    const lastComma = unsigned.lastIndexOf(",");
    const integerPart = unsigned.slice(0, lastComma).replace(/\D/g, "");
    const decimalPart = unsigned.slice(lastComma + 1).replace(/\D/g, "").slice(0, 2);
    normalized = `${integerPart || "0"}${decimalPart ? `.${decimalPart}` : ""}`;
  } else if (unsigned.includes(".")) {
    const parts = unsigned.split(".");
    const lastPart = parts[parts.length - 1] ?? "";
    const looksLikeDecimal = parts.length === 2 && lastPart.length > 0 && lastPart.length !== 3;

    if (looksLikeDecimal) {
      const integerPart = parts[0].replace(/\D/g, "");
      const decimalPart = lastPart.replace(/\D/g, "").slice(0, 2);
      normalized = `${integerPart || "0"}${decimalPart ? `.${decimalPart}` : ""}`;
    } else {
      normalized = parts.join("").replace(/\D/g, "");
    }
  } else {
    normalized = unsigned.replace(/\D/g, "");
  }

  if (!normalized) return "";
  return negative ? `-${normalized}` : normalized;
}

export function parseMoneyInput(value?: string | number) {
  const normalized = normalizeMoneyString(value);
  if (!normalized) return 0;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function sanitizeMoneyInput(value?: string | number) {
  const normalized = normalizeMoneyString(value);
  if (!normalized) return "";

  const [integerPart, decimalPart] = normalized.split(".");
  const sign = integerPart.startsWith("-") ? "-" : "";
  const integerDigits = integerPart.replace(/\D/g, "");
  const safeInteger = integerDigits ? String(Number(integerDigits)) : "0";

  if (decimalPart !== undefined && decimalPart.length > 0) {
    return `${sign}${safeInteger}.${decimalPart.slice(0, 2)}`;
  }

  return `${sign}${safeInteger}`;
}

export function formatMoneyInput(value?: string | number) {
  if (value === null || value === undefined) return "";

  const raw = sanitizeMoneyInput(value);
  if (!raw) return "";

  const hasDecimal = raw.includes(".");
  const decimalLength = hasDecimal ? Math.min(raw.split(".")[1]?.length ?? 0, 2) : 0;
  const parsed = Number(raw);
  if (!Number.isFinite(parsed)) return "";

  return parsed.toLocaleString("tr-TR", {
    minimumFractionDigits: decimalLength > 0 ? decimalLength : 0,
    maximumFractionDigits: decimalLength > 0 ? 2 : 0,
  });
}

export function formatTry(value: number) {
  return value.toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 2,
  });
}
